import { call, put, takeLatest } from 'redux-saga/effects';

import * as url from '../../helpers/url_helper';

// Crypto Redux States
import { POcomparisonTypes } from './actionTypes';
import { getComodityListByPOFail, getComodityListByPOSuccess } from './actions';

export const fetchPOcomparison = async (data: any) => {
  const { number } = data;
  const { sizePerPage, page } = data.pagination;
  const path = url.API_URL;
  const getAuthUser = localStorage.getItem('authUser');
  let user;
  if (getAuthUser) {
    user = JSON.parse(getAuthUser);
  }

  const query = `query {
    GetComodityListByPO(PONumber:"${number}", userId:"${user.id}",
	 Pagination:{
        sizePage:${sizePerPage},
        actualPage:${page},
      } ) {
        comodityData{ 
        Pieces
        PartNumber        
        WarehouseReceiptNumber
        SupplierPONumber    
        PurchaseOrderGUID
        Description
        }     
        CountItems
    }
}`;
  const response = await fetch(path, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      query,
    }),
  }).then((res) => res.json());
  return response?.data?.GetComodityListByPO;
};

function* fetchPOcomparisonSaga(data: any) {
  try {
    const response: Promise<any> = yield call(fetchPOcomparison, data.payload);
    yield put(getComodityListByPOSuccess(response));
  } catch (error) {
    yield put(getComodityListByPOFail(error));
  }
}

function* POcomparisonSaga() {
  yield takeLatest(
    POcomparisonTypes.GET_COMODITY_LIST_BY_PO,
    fetchPOcomparisonSaga,
  );
}

export default POcomparisonSaga;
